/* Copyright (c) 2023 Xperi. All Rights Reserved. */

import React, { FunctionComponent } from 'react';

import { InteractiveComponents } from '../../../core/enums';
import { RootState, useTivoSelector } from '../../../core/tivo/tivo-redux-wrapper';
import { Caret } from '../../common';

import './LiveTvActionStripInteractiveLayer.scss';

const LiveTvActionStripInteractiveLayer: FunctionComponent = (): JSX.Element => {
    const activeComponent = useTivoSelector(
        (state: RootState) => state.interactiveLayer.activeComponent,
    );

    const actionsItemLength = useTivoSelector(
        (state: RootState) => state.infoBanner.actionItemsCount,
    );
    return (
        <React.Fragment>
            <Caret
                direction={InteractiveComponents.WEST}
                className="actionbar-west"
                active={activeComponent === InteractiveComponents.WEST}
                visible={actionsItemLength > 1}
            />

            <Caret
                direction={InteractiveComponents.EAST}
                className="actionbar-east"
                active={activeComponent === InteractiveComponents.EAST}
                visible={actionsItemLength > 1}
            />
        </React.Fragment>
    );
};

export default LiveTvActionStripInteractiveLayer;
